import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MemberService, AlertService } from '../../../services';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { StorageUtil } from '../../../models';

@Component({
  selector: 'app-email-to',
  templateUrl: './email-to.component.html',
  styleUrls: ['./email-to.component.css']
})
export class EmailToComponent implements OnInit {

  @Input() users = [];
  @Input() sendToPlayers: boolean;
  @Output() close: EventEmitter<void> = new EventEmitter();

  form: FormGroup;
  Editor = ClassicEditor;

  constructor(
    private fb: FormBuilder,
    private memberService: MemberService,
    private alertService: AlertService,
    private spinner: Ng4LoadingSpinnerService
  ) {
    this.form = this.fb.group({
      sendToParents: [null],
      sendToPlayers: [null],
      subject: [null, Validators.required],
      message: [null, Validators.required]
    });
  }

  ngOnInit() {
    if (this.sendToPlayers) {
      this.form.patchValue({
        sendToPlayers: this.sendToPlayers,
      })
    }
  }

  onClose(event) {
    event.preventDefault();
    this.close.emit();
  }

  onSubmit(event) {
    event.preventDefault();

    const data = this.form.value;
    const clubId = +localStorage.getItem('clubId');

    this.spinner.show();

    this.memberService.sendEmailToPlayers({
      userIDs: this.users.map(u => u.userID),
      sendToParents: !!data.sendToParents,
      sendToPlayers: !!data.sendToPlayers,
      subject: data.subject,
      message: data.message,
      senderID: +StorageUtil.userID //Added new TW ID-28067215 (12-04-2022)
    }, clubId).subscribe(
      res => {
        this.spinner.hide();
        if (res) {
          this.alertService.success('HIGH FIVE! your emails were sent successfully.');
          this.close.emit();
        } else {
          this.alertService.error('WE HAVE A PROBLEM! Emails were not sent.');
        }
      },
      err => {
        console.log(err);
        this.spinner.hide();
        this.alertService.error('WE HAVE A PROBLEM! Emails were not sent.');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/email-to/email-to.component.ts